"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = void 0;
exports["default"] = Close;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Close(props) {
  var onClick = props.onClick,
    _props$closeLabel = props.closeLabel,
    closeLabel = _props$closeLabel === void 0 ? 'Close' : _props$closeLabel,
    className = props.className,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    "aria-label": props['aria-label'] || closeLabel,
    className: (0, _classnames["default"])('rrui__button-reset', 'rrui__outline', 'rrui__close', className)
  }, children);
}
var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 22 21",
    className: "rrui__close__icon"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    className: "rrui__close__icon-path",
    transform: "translate(-1367.000000, -40.000000)",
    strokeWidth: "1"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1368.000000, 41.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.807611845,0.307611845 L19.1923882,18.6923882"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.807611845,0.307611845 L19.1923882,18.6923882",
    transform: "translate(10.000000, 9.500000) scale(-1, 1) translate(-10.000000, -9.500000) "
  })))));
};
exports.CloseIcon = CloseIcon;
Close.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  closeLabel: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
//# sourceMappingURL=Close.js.map